import { createAuthRefreshTokenStorageEngine } from '@core/modules/auth/state/auth-storage.guard';
import { LOCAL_STORAGE_ENGINE, SESSION_STORAGE_ENGINE } from '@ngxs/storage-plugin';
import { StorageKey } from '@ngxs/storage-plugin/internals';
import { AppPersistedState } from '../state/app.persisted.state';

/*
 * Feature states are named by their `@State({ name })` string, never by class: importing a lazily
 * provided state class here pulled its page components (and ngx-quill, ngx-mask, socket.io-client)
 * into the initial bundle. The plugin resolves a class key to the same state name, so the storage
 * item names are unchanged; dot-notation keys are hydrated when the lazy state registers (UpdateState).
 */
export const PERSISTENT_STATES_REGISTRY: StorageKey[] = [
  // website-web#59: its own engine - a tab writes the shared session only when its own token changed (R-WLT2, R-WLT6)
  { engine: () => createAuthRefreshTokenStorageEngine(() => globalThis.localStorage), key: 'auth.refreshToken' },
  { engine: LOCAL_STORAGE_ENGINE, key: 'auth.sessionExpiredAt' },
  { engine: SESSION_STORAGE_ENGINE, key: 'cart' }, // CartState: the whole cart survives a reload (cart R-C17)
  { engine: SESSION_STORAGE_ENGINE, key: 'chat' }, // ChatState
  //
  // Search states: only the search form. Results, catalogues and polling progress stay in memory - each
  // progressive-search poll re-serialised the whole slice; a reload resets them anyway (`resetStatesBeforeUnload`).
  { engine: SESSION_STORAGE_ENGINE, key: 'reservations.searchForm' },
  { engine: SESSION_STORAGE_ENGINE, key: 'tours.searchForm' },
  { engine: SESSION_STORAGE_ENGINE, key: 'hotels.searchForm' },
  { engine: SESSION_STORAGE_ENGINE, key: 'avia.searchForm' },
  // Cruises phase 4: only the search form - the draft holds guests' names and passports, kept in memory only (M-13)
  { engine: SESSION_STORAGE_ENGINE, key: 'cruises.searchForm' },
  AppPersistedState
];
